import React, { useCallback } from "react";
import { AppointmentDate, onSelectDateCallback, Slot } from "../../../Models/Types";
import { parseDate } from "../../../Utils/StringFunctions.ts";

interface SlotsProps {
    appointmentDate : AppointmentDate,
    onSelectDate : onSelectDateCallback
}

export default function Slots(props : SlotsProps) {
    const {slots, date} = props.appointmentDate;
    const {onSelectDate} = props;

    const onSlotClick = useCallback((slot : Slot) => {
        const selected : AppointmentDate = {
            date : date,
            slots : [slot]
        }
        onSelectDate(selected);
    }, [date])
    return (
        <div className="tile">
            <div className="tile-header">{parseDate(date)}</div>
            {
                slots.map(slot => <div onClick={() => onSlotClick(slot)} className="tile-time pm">{slot.start}</div>)
            }
        </div>
    )
}